import {
  provideHttpClient,
  withInterceptorsFromDi
} from '@angular/common/http';
import { APP_ID, APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { RouterModule } from '@angular/router';
import {
  APPLICATION_CONFIGURATION_PATH,
  APPLICATION_CONFIGURATION_URL
} from '@com-delta-idp/angular-core/environment/tokens';
import { SmartModule as LoginModalSmartModule } from '@com-delta-idp/mnx-login';
import { FooterComponent } from '@com-delta-idp/mnx-sitewide-footer';
import { HeaderComponent } from '@com-delta-idp/mnx-sitewide-header';
import {
  installTrackJS,
  type OAuthFeatureConfig,
  provideStore as provideSitewideStore,
  TrackJsConfigService
} from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import {
  provideTrackJsConfigService,
  SkyClubComponent,
  SmartModule as SkyClubModule
} from '@com-delta-idp/mnx-sky-club';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { AppComponent } from './app.component';

const oAuthFeatureConfig: OAuthFeatureConfig = {
  app: 'SKYCLUB',
  endpointKey: 'SKY_CLUB_LOGIN_AUTH_CONFIG'
};
@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    StoreModule.forRoot({}),
    EffectsModule.forRoot([]),
    LoginModalSmartModule,
    SkyClubModule,
    RouterModule.forRoot(
      [
        {
          path: 'sky-club/purchase-membership',
          component: SkyClubComponent
        }
      ],
      {
        scrollPositionRestoration: 'enabled'
      }
    ),
    HeaderComponent,
    FooterComponent
  ],
  providers: [
    {
      provide: APPLICATION_CONFIGURATION_URL,
      useValue: '/content/www/en_US/config/sky-club.commonconfig.json'
    },
    {
      provide: APPLICATION_CONFIGURATION_PATH,
      useValue: '/content/www/en_US/config/sky-club.commonconfig.json'
    },
    {
      provide: TrackJsConfigService,
      useFactory: provideTrackJsConfigService()
    },
    {
      provide: APP_INITIALIZER,
      useFactory: installTrackJS,
      deps: [TrackJsConfigService],
      multi: true
    },
    {
      provide: 'OAUTH_FEATURE_CONFIG',
      useValue: oAuthFeatureConfig
    },
    {
      provide: 'REDIRECT',
      useValue: false
    },
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimationsAsync(),
    provideSitewideStore(),
    { provide: APP_ID, useValue: 'home' }
  ]
})
export class AppModule {}
